<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781429997973_toc01#toctitle1" id="title1"><span><strong class="b">ACKNOWLEDGMENTS</strong></span></a></div>
<div class="p"><span>In addition to the usual sources that a nonfiction author would use in the writing of a book about true events, such as interviews and site visits, the following media sources were consulted for information, and attributions are made throughout the book where applicable: the <em class="i">Spokesman-Review</em>; the <em class="i">Seattle Times</em>; <em class="i">USA Today</em>; the <em class="i">Bismarck Tribune</em>; <em class="i">Billings Gazette</em>; the <em class="i">Pacific Northwest Inlander</em>; Fox News; CNN; MSNBC; <em class="i">Globe</em> magazine; <em class="i">The National Enquirer</em> and Internet sites such as <a href="http://fifthnail.blogspot.com" target="_blank"><span><span class="url">http://fifthnail.blogspot.com</span></span></a>. Dialogue used throughout the book was either obtained from a direct source, or it was based on witness statements that appeared both in the news media, some of which are listed above, and in official sources. I would like to also acknowledge the work of <em class="i">Coeur d’Alene Press</em> staff writer Dave Turner, who carefully and painstakingly reported every detail of the Wolf Lodge murders case as it developed.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429997973_ack01.vue?9de5960c